import * as React from "react";
const SvgMail = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.015 5.75 6.821 5.895a.25.25 0 0 0 .328 0l6.821-5.895zm15.235.89-7.106 6.14a1.75 1.75 0 0 1-2.288 0L3.75 6.64v10.804c0 .41.36.806.886.806h14.728c.525 0 .886-.396.886-.806zm-18-.084c0-1.31 1.105-2.306 2.386-2.306h14.728c1.281 0 2.386.997 2.386 2.306v10.888c0 1.31-1.105 2.306-2.386 2.306H4.636c-1.281 0-2.386-.997-2.386-2.306z",
    clipRule: "evenodd"
  }
));
export default SvgMail;
